import styled from 'styled-components';

export const Recipient = styled.div`
  display: flex;
  text-align: center;
`;

export const GiveItemStyle = styled.div`
  display: flex;
  padding: 5px 0px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
`;

export const NumberContainer = styled.div`
  display: flex;
  margin-right: 5px;
  height: 25px;
  width: 25px;
  border-radius: 20px;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const ColoredNumberContainer = styled(NumberContainer)`
  background-color: ${(props) => props.theme.colors.teal2};
  color: ${(props) => props.theme.colors.white};
`;
